import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export interface SiteIntelItem {
  id: string;
  observation: string;
  solution_type: string | null;
  priority: string | null;
  tags: string[] | null;
  created_at: string;
  converted_to_estimate_id: string | null;
  captured_by: { id: string; full_name: string | null } | null;
  estimate: { id: string; estimate_number: string | null; status: string | null } | null;
}

/** Explicit columns: site_intel is staff-only, but the app never selects `*`. */
const SITE_INTEL_COLUMNS = `
  id, observation, solution_type, priority, tags, created_at, converted_to_estimate_id,
  captured_by:users!site_intel_captured_by_user_id_fkey(id, full_name),
  estimate:estimates!fk_site_intel_estimate(id, estimate_number, status)
`;

export function siteIntelQueryKey(locationId: string | undefined) {
  return ['site-intel', locationId] as const;
}

export function useSiteIntel(locationId: string | undefined) {
  return useQuery({
    queryKey: siteIntelQueryKey(locationId),
    enabled: !!locationId,
    queryFn: async () => {
      if (!locationId) throw new Error('Location ID required');
      const { data, error } = await supabase
        .from('site_intel')
        .select(SITE_INTEL_COLUMNS)
        .eq('location_id', locationId)
        .order('created_at', { ascending: false });
      if (error) throw error;
      return (data ?? []) as unknown as SiteIntelItem[];
    },
    staleTime: 60 * 1000,
  });
}
